import { imageUrl } from '@helpers/image';
import { Device, from } from '@helpers/media';
import Breadcrumb from '@stories/Components/Breadcrumb/Breadcrumb';
import SiteWide from '@stories/Components/Global/SiteWide/SiteWide';
import React from 'react';
import S from './HeroInner.styles';
const HeroInner = ({ breadcrumb, image, parallax = false, subtitle, title, }) => {
    return (React.createElement(S.Container, { isActive: true, flush: "both", fullWidth: true, parallax: parallax },
        React.createElement(SiteWide, null,
            React.createElement(S.ContentWrapper, null,
                breadcrumb && React.createElement(Breadcrumb, { items: breadcrumb }),
                subtitle && React.createElement(S.Subtitle, null, subtitle),
                React.createElement(S.Title, null, title))),
        image && (React.createElement(S.ImageWrapper, null,
            React.createElement("picture", null,
                React.createElement("source", { media: from(Device.TabletLarge), srcSet: [
                        `${imageUrl(image, { heightratio: 0.4255, width: 360 })} 360w`,
                        `${imageUrl(image, { heightratio: 0.4255, width: 480 })} 480w`,
                        `${imageUrl(image, { heightratio: 0.4255, width: 960 })} 960w`,
                        `${imageUrl(image, { heightratio: 0.4255, width: 1440 })} 1440w`,
                        `${imageUrl(image, { heightratio: 0.4255, width: 1920 })} 1920w`,
                    ].join(',') }),
                React.createElement(S.Image, { alt: "", loading: "eager", role: "presentation", sizes: "100vw", src: imageUrl(image, { heightratio: 0.5306, width: 1920 }), srcSet: [
                        `${imageUrl(image, { heightratio: 0.5306, width: 360 })} 360w`,
                        `${imageUrl(image, { heightratio: 0.5306, width: 480 })} 480w`,
                        `${imageUrl(image, { heightratio: 0.5306, width: 960 })} 960w`,
                        `${imageUrl(image, { heightratio: 0.5306, width: 1440 })} 1440w`,
                        `${imageUrl(image, { heightratio: 0.5306, width: 1920 })} 1920w`,
                    ].join(',') }))))));
};
export default HeroInner;
